export function credentialIdempotencyKey(): string {
  return `credential-${crypto.randomUUID()}`;
}

export interface CredentialOperationKeyState {
  intent?: string;
  key?: string;
}

export function credentialOperationKeyForIntent(
  state: CredentialOperationKeyState,
  intent: string,
  createKey: () => string = credentialIdempotencyKey,
): string {
  if (state.intent !== intent || !state.key) {
    state.intent = intent;
    state.key = createKey();
  }
  return state.key;
}

export function clearCredentialOperationKey(
  state: CredentialOperationKeyState,
  intent: string,
): void {
  if (state.intent === intent) {
    state.intent = undefined;
    state.key = undefined;
  }
}
